import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "icon-arrow-right",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Shape",
			d: "M9.41042 3.57733C9.73586 3.25189 10.2635 3.25189 10.5889 3.57733L16.4223 9.41066C16.7477 9.7361 16.7477 10.2637 16.4223 10.5892L10.5889 16.4225C10.2635 16.7479 9.73586 16.7479 9.41042 16.4225C9.08498 16.0971 9.08498 15.5694 9.41042 15.244L13.8212 10.8333H4.16634C3.7061 10.8333 3.33301 10.4602 3.33301 9.99992C3.33301 9.53968 3.7061 9.16658 4.16634 9.16658H13.8212L9.41042 4.75584C9.08498 4.4304 9.08498 3.90277 9.41042 3.57733Z",
			fill: "white"
		})
	})]
});
const ForwardRef = forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
